// extracted by mini-css-extract-plugin
module.exports = {"linkBtn":"LoginForm_linkBtn__A97VD","divider":"LoginForm_divider__4y_bO"};